import { Spec, SpecCreate } from "../models/specs";
import api from "./index";

const BASE = '/specs';

export const getAllSpecs = async (params = {}) => {
    try {
        const response = await api.get(`${BASE}/getall`, { params });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch specs:', error);
        throw error;
    }
};


export const createSpec = async (spec: SpecCreate): Promise<Spec> => {
    try {
        const response = await api.post(`${BASE}/create`, spec);
        return response.data as Spec;
    } catch (error) {
        console.error("Failed to create spec:", error);
        throw error;
    }
};

export const getMySpecs = async (params = {}) => {
    try {
        const response = await api.get(`${BASE}/myspecs`, { params });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch specs:', error);
        throw error;
    }
};


export const getSpecByID = async (spec_id: number) => {
    try {
        const response = await api.get(`${BASE}/${spec_id}`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch spec:', error);
        throw error;
    }
};


// export const updateSpecByID = async (updates: SpecUpdate): Promise<Spec> => {
//     try {
//         const response = await api.patch(`${BASE}/update`, updates);
//         return response.data as Spec;
//     } catch (error) {
//         console.error("Failed to update spec:", error);
//         throw error;
//     }
// };

export const getVerticals = async () => {
    try {
        const response = await api.get(`${BASE}/getverticals`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch verticals:', error);
        throw error;
    }
};

export const getStates = async () => {
    try {
        const response = await api.get(`${BASE}/getstates`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch states:', error);
        throw error;
    }
};


export const getSupply = async (params = {}) => {
    try {
        const response = await api.get(`${BASE}/getsupply`, { params });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch supply:', error);
        throw error;
    }
};

export const getMySupply = async (params = {}) => {
    try {
        const response = await api.get(`${BASE}/getmysupply`, { params });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch user supply:', error);
        throw error;
    }
};


export const isSpecOwner = async (spec_id: number): Promise<boolean> => {
    try {
        const response = await api.get(`${BASE}/${spec_id}/is_owner`);
        return response.data;
    } catch (error) {
        console.error("Failed to verify spec ownership:", error);
        throw error;
    }
};

// export const getUserSpecs = async (email: string): Promise<Spec[]> => {
//     try {
//         const response = await api.get(`${BASE}/user_specs`, { params: { email } });
//         return response.data as Spec[];
//     } catch (error) {
//         console.error(`Failed to fetch specs for ${email}:`, error);
//         throw error;
//     }
// };

export const deleteSpec = async (spec_id: string) => {
    try {
        const response = await api.delete(`${BASE}/delete/${spec_id}`);
        return response.data;
    } catch (error) {
        console.error('Failed to delete spec:', error);
        throw error;
    }
};

// export const migrateAllSpecs = async (emails: MigrateSpecsRequest) => {
//     try {
//         const response = await api.post(`${BASE}/migrateall`, emails);
//         return response.data as Spec[];
//     } catch (error) {
//         console.error("Failed to update spec:", error);
//         throw error;
//     }
// }